import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { ButtonValidate } from "../../../components/common/ButtonValidate";
import { GameQuestionActivityThree } from "./GameQuestionActvityThree";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	exerciseKeyboard: 4,
	winExerciseKeyboard: 5,
	failExerciseKeyboard: 6,
	netoChatOne: 7,
	dialogThree: 8,
	dialogFour: 9,
	exerciseBillets: 10,
	winExerciseBillets: 11,
	failExerciseBillets: 12,
	netoChatTwo: 13,
	clientChatOne: 14,
	dialogFive: 15,
	netoGoodbyeActivity: 16,
	winSubactivityThree: 17,
	failSubactivityThree: 18,
	dialogSix: 19,
}
let numberSumPoint = 0
export const Tema4SubtopicFourActivityThree = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema4], 3);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema4 activity 3");
			ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a01)
	})
	ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.winKeyboardQuiz, () => {
		setUiToShow(steps.winExerciseKeyboard)
	})
	ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.failKeyboardQuiz, () => {
		setUiToShow(steps.failExerciseKeyboard)
	})
	ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.winBilletsQuiz, () => {
		setUiToShow(steps.winExerciseBillets)
	})
	ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.failBilletsQuiz, () => {
		setUiToShow(steps.failExerciseBillets)
	})
	const questionData = {
		question: "El Cliente se ha despedido, ¿Qué debes responder?",
		img: imgsTopic4.netoWithEllipsisChat,
		options: {
			1: {
				text: "¡Gracias a usted! Vuelva pronto",
				isCorrect: true
			},
			2: { text: "De nada" },
			3: { text: "Regrese pronto" },
		},
	};
	const netoQuizAction = (statusResponse) => {
		if (statusResponse === 1) {
			setTimeout(() => {
				setUiToShow(steps.winSubactivityThree)
			}, 1000);
		} else if (statusResponse === 2) {
			setTimeout(() => {
				setUiToShow(steps.failSubactivityThree)
			}, 1000);
		}
	};
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 4, 10, 16].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicFour.initScene, 3);
						numberSumPoint = 0
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 3: ¡Vamos por esa primera venta!" />
					<DialogBarNew
						dialog={
							"¡Excelente! estas a punto de concretar tu primera venta."
						}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 4: Cobro de productos"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<HeaderRedPresentation name="Ejercicio: Atajos de teclado" />
					<DialogBarNew
						dialog={
							"¿Qué tecla debes seleccionar? después de haber escaneado los productos. Da clic en la que creas conveniente."
						}
						callback={() => {
							setUiToShow(steps.exerciseKeyboard);
							ObserverEmitter.emit(EVENTS.tema4.subtopicTwo.activityTwo.moveCameraOverKeyboard)
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.showKeyboard)
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.exerciseKeyboard && (
				<>
					<BarStatusActivies activities={tasksList} />
					<ButtonValidate
						name="Responder"
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.keyboardQuiz)
						}}
					>
					</ButtonValidate>
				</>
			)}
			{uiToShow === steps.winExerciseKeyboard && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={20}
						dialogModal="Lograste identificar correctamente un atajo del teclado. Esto demuestra tu habilidad para trabajar ágilmente con tus herramientas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							numberSumPoint += 20
							setUiToShow(steps.netoChatOne)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a03)
						}}
					/>
				</>
			)}
			{uiToShow === steps.failExerciseKeyboard && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={10}
						dialogModal="¡Ánimo! Recuerda que es importante conocer los atajos de teclado."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							numberSumPoint += 10
							setUiToShow(steps.netoChatOne)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a03)
						}}
					/>
				</>
			)}
			{uiToShow === steps.netoChatOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Muy bien recibo $50 pesos."
						}
						callback={() => {
							setUiToShow(steps.dialogThree);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a04)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={
							"De acuerdo con la información del cliente ¿Cuánto cambio debes regresar?"
						}
						callback={() => {
							setUiToShow(steps.dialogFour);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a05)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<HeaderRedPresentation name="Ejercicio: Entrega el cambio correcto." />
					<DialogBarNew
						dialog={
							"Da clic sobre el cambio correcto."
						}
						callback={() => {
							setUiToShow(steps.exerciseBillets);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.moveCameraToBillets);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.changebilletsTexture);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.showBillets);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.exerciseBillets && (
				<>
					<ButtonValidate
						name="Responder"
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityThree.billetsQuiz)
						}}
					>
					</ButtonValidate>
				</>
			)}
			{uiToShow === steps.winExerciseBillets && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="¡Felicitaciones! Has entregado el cambio adecuado. Esto refleja tu destreza en proporcionar un servicio al cliente impecable."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							numberSumPoint += 10
							setUiToShow(steps.netoChatTwo)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a06)
						}}
					/>
				</>
			)}
			{uiToShow === steps.failExerciseBillets && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={5}
						dialogModal="¡Animo! el cambio entregado no fue correcto. Asegúrate de practicar para mejorar tus habilidades en la atención al cliente."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							numberSumPoint += 5
							setUiToShow(steps.netoChatTwo)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a06)
						}}
					/>
				</>
			)}
			{uiToShow === steps.netoChatTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Son $20 pesos de cambio y su ticket."
						}
						callback={() => {
							setUiToShow(steps.clientChatOne);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a07)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.yolanda} alt="Yolanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Yolanda"
						dialog={
							"Gracias muy amable."
						}
						callback={() => {
							setUiToShow(steps.dialogFive);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub04.sub4_act3_a08)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFive && (
				<>
					<HeaderRedPresentation name="Ejercicio: Selecciona una respuesta." />
					<DialogBarNew
						dialog={
							"Lo has hecho increíble por ultimo selecciona la respuesta más oportuna."
						}
						callback={() => {
							setUiToShow(steps.netoGoodbyeActivity);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.netoGoodbyeActivity && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<GameQuestionActivityThree
						data={questionData}
						actionGameQuestion={netoQuizAction}
					/>
				</>
			)}
			{uiToShow === steps.winSubactivityThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="¡Excelente! Aunque terminemos de cobrar, siempre brindamos un servicio excelente."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: numberSumPoint + 10,
									subtema: tasksId.tema4.activities.subtema4,
								})
							);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							setUiToShow(steps.dialogSix)
						}}
					/>
				</>
			)}
			{uiToShow === steps.failSubactivityThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={5}
						dialogModal="¡Ánimo! Recuerda que debemos brindar un excelente servicio mientras el cliente esté en la tienda."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 4,
									pointsWin: numberSumPoint + 5,
									subtema: tasksId.tema4.activities.subtema4,
								})
							);
							setUiToShow(steps.dialogSix)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
						}}
					/>
				</>
			)}
			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={
							"Algo importante, no te guíes por la apariencia, pero siempre debes estar al pendiente de las personas que visitan la Tienda."
						}
						callback={() => {
							navigation("/home4/tema4/subtema4/activityFour");
						}}
					></DialogBarNew>
				</>
			)}

		</>
	)
}
